import list from "./list";
import listStruct from "./listStruct";
import show from "./show";
import update from "./update";

export default {
  namespaced: true,
  modules: {
    list,
    show,
    update,
    listStruct,
  },
};
